import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { ChangeDetectorRef, Injectable, Injector } from '@angular/core';
import { catchError, distinctUntilChanged, Observable, throwError } from 'rxjs';
import { ApiFailureDialogService } from '../api-failure-dialog/api-failure-dialog.service';
import { AuthService, BaseSiteService } from '@spartacus/core';



@Injectable()
export class ApiErrorInterceptor implements HttpInterceptor {
private currentSite:any;
private loggedin:any;
  private apiStatusMap: Map<string, { success: boolean; failed: boolean }> = new Map();

  constructor( private authService:AuthService,private injector: Injector,private baseSiteService:BaseSiteService) {

    this.baseSiteService.getActive().subscribe(site => {
      this.currentSite =site;
    });
    this.authService.isUserLoggedIn().pipe(distinctUntilChanged()).subscribe((isLoggedIn: any) => {
    this.loggedin=isLoggedIn;
    
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const apiKey = this.getApiKey(req);
    

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (!window.location.href.includes('not-found')) {
          let errorType: string | undefined;
          let errormessage: string | undefined;

          try {
            if (typeof error.error === 'string') {
              const parsedError = JSON.parse(error.error);
              errorType = parsedError.errors?.[0]?.type;
              errormessage = parsedError.errors?.[0]?.message;
            } else if (typeof error.error === 'object' && error.error !== null) {
              errorType = error.error.errors?.[0]?.type;
              errormessage = error.error.errors?.[0]?.message;
            }
          } catch (e) {
            console.error('Failed to parse error response:', e);
          }

          if (error.error?.error  && error.error?.error == "invalid_token"  || errormessage?.includes('No content page found') || errormessage?.includes('Value is required, null given for key: soldToId') || errormessage?.includes('Access is denied') || errormessage?.includes('Full authentication is required') || req.url.includes('checkCartExistforSeason') || req.url.includes('setModelNPrice') ||  req.url.includes('oauth/revoke') || req.url.includes('oauth/token') || req.url.includes('/orgUsers') || req.url.includes('/flu-vaccine-resources/accessResource')) {
            return throwError(() => error);
          }

          if (
            errorType !== 'CMSItemNotFoundError' &&
            errorType !== 'UnauthorizedError' &&
            errorType !== 'InvalidTokenError' &&
            errorType !== 'InvalidBearerTokenError' &&
            errorType !== 'UnknownResourceError' &&
            !req.url.includes('json')
          ) {
            this.updateApiStatus(apiKey, false); // mark as failed

            if (this.shouldShowPopup()) {
              if (localStorage.getItem('FailureDailog') !== 'true' && this.loggedin) {
                  if(this.currentSite=='seqirusb2b-uk'){
                    if(window.location.href.includes('my-account')){
                      if( localStorage.getItem('dashboarduk')=='true'){
                        const dialogService = this.injector.get(ApiFailureDialogService);
                        dialogService.openErrorDialog();
                        localStorage.setItem('FailureDailog', 'true'); 
                      }
                    }
                    else{
                      const dialogService = this.injector.get(ApiFailureDialogService);
                    dialogService.openErrorDialog();
                    localStorage.setItem('FailureDailog', 'true'); 
                    }
                   

                  }else{
                    const dialogService = this.injector.get(ApiFailureDialogService);
                    dialogService.openErrorDialog();
                    localStorage.setItem('FailureDailog', 'true');  
                  }
              }
            }
          }
        }

        return throwError(() => error);
      })
    );
  }

  private getApiKey(req: HttpRequest<any>): string {
    // Normalize the URL to identify duplicate calls
    return req.url.split('?')[0]; // remove query params if needed
  }

  private updateApiStatus(apiKey: string, isSuccess: boolean): void {
    const current = this.apiStatusMap.get(apiKey) || { success: false, failed: false };
    if (isSuccess) {
      current.success = true;
    } else {
      current.failed = true;
    }
    this.apiStatusMap.set(apiKey, current);
  }

  private shouldShowPopup(): boolean {
    for (const [_, status] of this.apiStatusMap.entries()) {
      if (status.failed && !status.success) {
        return true; // show popup only if all calls to this API failed
      }
    }
    return false; // no popup if at least one success for each failed API
  }
}
